import gsap, { Flip } from "@/lib/gsap";
import SimpleRichTextComponent from "@/components/SimpleRichText";
import { forwardRef, useRef, useEffect, useState } from "react";
import {
  SVGPlusAccordion as SVGPlusAccordionComponent,
  SVGMinusAccordion as SVGMinusAccordionComponent,
} from "@/lib/svg";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SimpleRichText = SimpleRichTextComponent as any;
const SVGPlusAccordion = SVGPlusAccordionComponent as any;
const SVGMinusAccordion = SVGMinusAccordionComponent as any;
import {
  ItemContainer,
  IconPlus,
  IconMinus,
  Heading,
  Title,
  ContentAccordion,
  IconWrapper,
  Article,
} from "./styles";

export type AccordionItemProps = {
  _key?: string;
  className?: string;
  title?: string;
  content?: Record<string, any>;
  isOpen?: boolean;
  handleClick: (event: any) => void;
};

const AccordionItem = forwardRef<HTMLDivElement, AccordionItemProps>(
  function AccordionItemComponent(props, ref) {
    const { _key, className, title, content, isOpen, handleClick } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const content = contentRef.current;
      if (!content) return;
      const state = Flip.getState(content, { props: "overflow" });

      if (isOpen) {
        content.style.height = "auto";
      } else {
        // When closing set overflow to hidden
        content.style.height = "0";
        content.style.overflow = "hidden";
      }

      Flip.from(state, {
        duration: 0.5,
        onComplete: () => {
          // When opening set overflow to visible AFTER the animation
          // so it doesn't cut the box-shadow of the cards
          if (window.getComputedStyle(content).height !== "0px") {
            content.style.overflow = "visible";
          } else {
            content.style.overflow = "hidden";
          }
        },
      });
    }, [isOpen]);

    return (
      <ItemContainer id={_key} className={className} ref={ref}>
        <Heading onClick={handleClick}>
          <IconWrapper>
            {isOpen ? (
              <IconMinus>
                <SVGMinusAccordion />
              </IconMinus>
            ) : (
              <IconPlus>
                <SVGPlusAccordion />
              </IconPlus>
            )}
          </IconWrapper>
          {title && <Title as="p">{title}</Title>}
        </Heading>

        {content && (
          <ContentAccordion /* $isOpen={isOpen} */ ref={contentRef}>
            <Article>
              <SimpleRichText body={content} />
            </Article>
          </ContentAccordion>
        )}
      </ItemContainer>
    );
  }
);

// Cast to fix React 17 + @types/react 18 compatibility issue
export default AccordionItem as any;
